import React from 'react';
import startCase from 'lodash/startCase';
import { commify } from 'utils/stringUtil';
import LinkText from 'components/LinkText';
import { formatDate } from 'utils/format';

export const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    render: function renderID(val) {
      return <LinkText>{val}</LinkText>;
    },
  },
  {
    title: 'Owner',
    render: function renderOwner(others) {
      const { merchant, user } = others.ledger;

      if (merchant) {
        return <span>{merchant.displayName}</span>;
      } else if (user) {
        return <span>{user.fullname}</span>;
      }

      return <span>-</span>;
    },
  },
  {
    title: 'Type',
    dataIndex: 'type',
    align: 'right',
    render: function renderType(val) {
      return <span>{startCase(val)}</span>;
    },
  },
  {
    title: 'Amount',
    dataIndex: 'delta',
    align: 'right',
    render: function renderAmount(val) {
      const symbol = val >= 0 ? '+' : '-';
      const color = symbol === '+' ? '#0eb53d' : '#e02323';
      return <span style={{ color }}>{symbol + commify(Math.abs(val))}</span>;
    },
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    align: 'right',
    render: function renderBalance(val) {
      return <span>{commify(val)}</span>;
    },
  },
  {
    title: 'Currency',
    dataIndex: 'currency',
    align: 'center',
    render: function renderCurrency(val) {
      return <span>{val.toUpperCase()}</span>;
    },
  },
  {
    title: 'Date',
    dataIndex: 'createdAt',
    render: function renderDate(val) {
      return <span>{formatDate(val)}</span>;
    },
  },
];

export default {
  columns,
};
